import { render, staticRenderFns } from "./lawMenu.vue?vue&type=template&id=4a6e81d9&scoped=true&"
import script from "./lawMenu.vue?vue&type=script&lang=js&"
export * from "./lawMenu.vue?vue&type=script&lang=js&"
import style0 from "./lawMenu.vue?vue&type=style&index=0&id=4a6e81d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e81d9",
  null
  
)

export default component.exports